export const allTokens = [
  "Guardian Golem TOKEN",
  "Looking Smart! TOKEN",
  "Fire Drake Whelp TOKEN",
  "Mimi, Right Paw Hellhound TOKEN",
  "Coco, Left Paw Hellhound TOKEN",
  "Silent Rider TOKEN",
  "Servant of Cocytus TOKEN",
  "Demon of Purgatory TOKEN",
  "Astaroth's Reckoning TOKEN",

  "Annihilating Onslaught TOKEN",
  "Remnant of Hollowness TOKEN",
  "Gilded Blade TOKEN",
  "Gilded Goblet TOKEN",
  "Gilded Boots TOKEN",
  "Ersatz Elimination TOKEN",
  "Melodious Monody TOKEN",
  "Fangs of Ardent Destruction TOKEN",
  "Wings of Desire TOKEN",
  "Scream Diffusion TOKEN",
  "Rulenye, Screaming Echo TOKEN",
  "Torrent of Despair TOKEN",
  "Great Testimony TOKEN",
  "Ravenous Sweetness TOKEN",

  "Sootspawn TOKEN",
  "Glittering Gold TOKEN",
  "Flame General's Regalia TOKEN",
  "Tidal Tyranny TOKEN",
  "Wolfling's Struggle TOKEN",
  "Fox of Invitation TOKEN",
  "Mercurial Might TOKEN",

  "Anne's Summoning TOKEN",
  "Resentful Blaze TOKEN",
  "Blood Arts TOKEN",
  "Darkest Desire TOKEN",
  "Keenedge Artifact TOKEN",

  "Carbuncle's Sparkle TOKEN",
  "Twilight Blade TOKEN",
  "Armored Tentacle TOKEN",
  "Assault Tentacle TOKEN",
  "Medusiana TOKEN",

  "Val, Trusty Getaway Car TOKEN",
  "Magitrain TOKEN",
  "Dutiful Steed TOKEN",
  "Bullet Bike TOKEN",
  "Arcane Personnel Carrier TOKEN",

  "Exterminus Weapon TOKEN",
  "Devoted Dragon TOKEN",

  "Instant Poison TOKEN",
  "Eternal Potion TOKEN",
  "Mysterian Missile TOKEN",
  "Aftershock TOKEN",

  "Lloyd TOKEN",
  "Victoria TOKEN",
  "Otohime's Vanguard TOKEN",

  "Assembly Droid TOKEN",
  "Repair Mode TOKEN",
  "Naterran Great Tree TOKEN",

  "Cute Earrings TOKEN",
  "Cool Earrings TOKEN",
  "Passion Earrings TOKEN",
  "Celestial Shikigami TOKEN",
  "Paper Shikigami TOKEN",
  "One-Tailed Fox TOKEN",
  "Destruction in White TOKEN",
  "Destruction in Black TOKEN",
  "Puppet TOKEN",
  "Ancient Artifact TOKEN",
  "Mystic Artifact TOKEN",
  "Serpent TOKEN",
  "Goblin King TOKEN",
  "Gargantuan Ghost TOKEN",
  "Crystalia Eve TOKEN",
  "Shield Guardian TOKEN",
  "Leonidas's Resolve TOKEN",
  "Magical Pawn TOKEN",
  "Megalorca TOKEN",
  "Hellflame Dragon TOKEN",
  "Draconic Weapon TOKEN",
  "Ephemeral Moon TOKEN",
  "Thorn Burst TOKEN",
  "Fairy Wisp TOKEN",
  "Fairy TOKEN",
  "Otohime's Bodyguard TOKEN",
  "Knight TOKEN",
  "Viking TOKEN",
  "Steelclad Knight TOKEN",
  "Strikeform Golem TOKEN",
  "Guardform Golem TOKEN",
  "Magic Sediment TOKEN",
  "Dragon TOKEN",
  "Mimi TOKEN",
  "Coco TOKEN",
  "Ghost TOKEN",
  "Forest Bat TOKEN",
  "Holy Falcon TOKEN",
  "Holy Tiger TOKEN",

  "Lococo's Teddy Bear TOKEN",
  "Gale Arrow TOKEN",
  "Storm Arrow TOKEN",
  "Quadra Magic TOKEN",
  "Elements of Creation TOKEN",
  "Curse of the Black Dragon TOKEN",
  "A Horrible Night TOKEN",
  "Luna's Doll TOKEN",
  "Eschamali Adviser TOKEN",
  "Eschamali Constable TOKEN",


  "Mimi, Infernal Right Paw TOKEN",
  "Coco, Infernal Left Paw TOKEN",

  "Enchanted Slippers TOKEN",
  "Enchanted Dress TOKEN",
  "Cute Pendant TOKEN",
  "Cute Tiara TOKEN",
  "Cool Pendant TOKEN",
  "Cool Tiara TOKEN",
  "Passion Pendant TOKEN",
  "Passion Tiara TOKEN",

  "Seeds of Salvation TOKEN",
  "All-Access Search TOKEN",
  "Adorn with Jewels TOKEN",
  "Ginger's Curse TOKEN",
  "Youthful Strike TOKEN",
  "Adelle, Jealous Dragon TOKEN",
  "Diurnal Slumber TOKEN",
  "Righteous Conviction TOKEN",
  "Totem of Madness TOKEN",
  "Bansai Suzuki, Clone Technique TOKEN",

  "Ames Amulet TOKEN",
  "Princess Sword TOKEN",
  "Holy Castle Sword, Avalon TOKEN",
  "Queen's Console TOKEN",
  "Neneka, Mirror Image TOKEN",
  "Chaos Grimoire TOKEN",
  "Wand of Mirage TOKEN",
  "Ice Drachen TOKEN",
  "Proof of Bonds TOKEN",
  "Skullfather TOKEN",
  "Dark Axe Nachtfang TOKEN",
  "Glorious Feather TOKEN",

  "Dread Pirate's Flag TOKEN",
  "Multi-Headed Test Subject TOKEN",

  "Crest: Krulle, Heir to Unkilling TOKEN",
  "Crest: Octrice, Hollowness Manifest TOKEN",
  "White Psalm, New Revelation TOKEN",
  "Black Psalm, New Revelation TOKEN",
  "Crest: Galmieux, Ardor Manifest TOKEN",
  "Crest: Sham-Nacha, Heir to Entwining TOKEN",
  "Crest: Marwynn, Despair Manifest TOKEN",
  "Crest: Himeka, Heir to Repose TOKEN",
  "Crest: Congregant of Repose TOKEN",
  "Crest: Supplicant of Repose TOKEN",
  "Crest: Mjerrabaine, Great Manifest TOKEN",

  "Rulenye, Echoing Scream TOKEN",

  "Kyoko Igarashi [Love Letter] TOKEN",
  "Shiki Ichinose [Tsubomi] TOKEN",
  "Sachiko Koshimizu [Lunatic Show] TOKEN",
  "Kaede Takagaki [Nation Blue] TOKEN",
  "Riina Tada [Eight-Beat Rocker] TOKEN",
  "Sae Kobayakawa [Pastel Pink Love] TOKEN",
  "Ranko Kanzaki [Nation Blue] TOKEN",
  "Shin Sato [Gutsy☆Reporter] TOKEN",
  "Akari Tsujino [Brand New!] TOKEN",
  "Asuka Ninomiya [Saite Jewel] TOKEN",
  "Yoshino Yorita [Warrior's Path] TOKEN",
  "Chie Sasaki [Step to Mirai] TOKEN",
  "Arisu Tachibana [Ikenai GO AHEAD] TOKEN",
  "Yukimi Sajo [Hands and Days Together] TOKEN",

  "Lyelth's Marionette TOKEN",
  "Verdant Prayer TOKEN",
  "Curse of Suffering TOKEN",
  "Emergency Summoning TOKEN",
  "Reactive Barrier TOKEN",
  "Lilium's Hatchling TOKEN",
  "Lilium's Dragon TOKEN",
  "Holy Cavalier TOKEN",
  "Cyclical Guidance TOKEN",
  "Crest: Wilbert, Desolate Paladin TOKEN",

  "Ameth Amulet TOKEN",
  "Sanctum Blade Avalon TOKEN",
  "Mirror Image Neneka TOKEN",
  "Mirage Wand TOKEN",
  "Eisdrache TOKEN",
  "Precious Memento TOKEN",

  "Her Holiness's Decree TOKEN",
  "Shadow General TOKEN",
  "Radiant Artifact TOKEN",
];
